import { useWidgetData } from '../useWidgetData'

import { StatisticValueMetadata } from '../../../types/court/court'
import { ReportInterval } from '../../../types/report/report'
import { createReportQuery } from '../../../utils/reportUtils'

export const useActiveMembersWidget = (interval: ReportInterval) =>
  useWidgetData<StatisticValueMetadata>(
    `active-members?${createReportQuery(interval)}`
  )
